// Spanish translations
const es = {
  // Cover Screen
  cover: {
    title: "Reino del Ajedrez",
    subtitle: "Corte del Rey",
    riseOfDukes: "El Ascenso de los Duques",
    enter: "ENTRAR",
    aboutUs: "SOBRE NOSOTROS",
    tagline: "Donde nacen las leyendas, y cada movimiento cuenta una historia",
    selectLanguage: "Seleccionar Idioma"
  },
  
  // Authentication
  auth: {
    login: "Iniciar Sesión",
    register: "Registrarse",
    email: "Correo Electrónico",
    password: "Contraseña",
    confirmPassword: "Confirmar Contraseña",
    username: "Nombre de Usuario",
    forgotPassword: "¿Olvidaste tu contraseña?",
    noAccount: "¿No tienes una cuenta?",
    hasAccount: "¿Ya tienes una cuenta?",
    signUp: "Registrarse",
    signIn: "Iniciar Sesión",
    orContinueWith: "O continuar con",
    guest: "Jugar como Invitado",
    logout: "Cerrar Sesión"
  },
  
  // Lobby
  lobby: {
    title: "VESTÍBULO DEL PATIO",
    subtitleRise: "El Ascenso de los",
    subtitleDukes: "Duques",
    quickPlay: "JUEGO RÁPIDO",
    createRoom: "CREAR SALA",
    joinRoom: "UNIRSE A SALA",
    settings: "Configuración",
    skins: "SKINS",
    friends: "Amigos",
    chat: "Chat",
    spectate: "OBSERVAR",
    roomCode: "Código de Sala",
    enterRoomCode: "Ingresa el código de sala...",
    join: "Unirse",
    create: "Crear",
    private: "Privada",
    public: "Pública",
    players: "Jugadores",
    waiting: "Esperando oponente...",
    ready: "Listo",
    start: "Iniciar Juego",
    gameSetup: "CONFIGURACIÓN",
    chooseVariant: "Elige Variante y Modo",
    multiplayer: "MULTIJUGADOR",
    onlineMatches: "Partidas en Línea",
    profile: "Perfil",
    messages: "Mensajes",
    assistant: "Asistente",
    help: "Ayuda",
    exit: "Salir"
  },
  
  // Game
  game: {
    white: "Blancas",
    black: "Negras",
    whiteToMove: "Mueven las Blancas",
    blackToMove: "Mueven las Negras",
    check: "¡Jaque!",
    checkmate: "¡Jaque Mate!",
    stalemate: "¡Tablas por Ahogado!",
    draw: "Tablas",
    resign: "Rendirse",
    resigns: "Se Rinde",
    forfeits: "Abandona",
    offerDraw: "Ofrecer Tablas",
    acceptDraw: "Aceptar Tablas",
    declineDraw: "Rechazar Tablas",
    newGame: "Nueva Partida",
    leave: "Salir",
    rules: "REGLAS",
    moveHistory: "Historial de Movimientos",
    noMovesYet: "Sin movimientos aún",
    movesWillAppear: "Los movimientos aparecerán aquí mientras juegas",
    yourTurn: "Tu Turno",
    opponentTurn: "Turno del Oponente",
    gameOver: "Fin del Juego",
    youWin: "¡GANASTE!",
    youLose: "Perdiste",
    whiteWins: "¡Ganan las Blancas!",
    blackWins: "¡Ganan las Negras!",
    drawGame: "¡Es un Empate!",
    playAgain: "Jugar de Nuevo",
    backToLobby: "Volver al Vestíbulo",
    classic: "CLÁSICO",
    kingsCourt: "CORTE DEL REY",
    fightToBeKing: "Lucha por ser Rey",
    kingCaptured: "¡Rey Capturado!",
    winner: "Ganador",
    rematch: "Revancha",
    decline: "Rechazar",
    waiting: "Esperando...",
    acceptRematch: "Aceptar Revancha",
    wantsRematch: "¡quiere una revancha!",
    rematchAccepted: "¡Revancha aceptada! Iniciando nueva partida...",
    rematchDeclined: "Revancha rechazada. Volviendo al vestíbulo...",
    waitingForOpponent: "Esperando oponente...",
    startingNewGame: "Iniciando nueva partida...",
    continue: "Continuar"
  },
  
  // Settings
  settings: {
    title: "Configuración",
    boardCustomization: "Personalización del Tablero y Piezas",
    livePreview: "Vista Previa en Vivo",
    previewDescription: "Mira cómo se ve tu personalización",
    boardTheme: "Colores del Tablero",
    pieceTheme: "Colores de Piezas",
    customColors: "Colores Personalizados",
    presetThemes: "Temas Predefinidos",
    lightSquares: "Casillas Claras",
    darkSquares: "Casillas Oscuras",
    whitePieces: "Piezas Blancas",
    blackPieces: "Piezas Negras",
    coordinateColor: "Color de Coordenadas",
    coordinateDescription: "Personaliza el color de los números (1-8) y letras (a-h)",
    chessPieceSkins: "Skins de Piezas de Ajedrez",
    chessPieceSkinsDescription: "Reemplaza las piezas estándar con skins 3D premium",
    dukeSkins: "Skins de Duque",
    dukeSkinsDescription: "Elige skins de Duque para cada lado - ¡el tema del tablero se ajusta automáticamente!",
    whiteSideDuke: "Duque del Lado Blanco",
    blackSideDuke: "Duque del Lado Negro",
    autoMatchBoard: "Auto-coincidir colores del tablero con el Duque",
    saveAndClose: "Guardar y Cerrar",
    reset: "Restablecer",
    close: "Cerrar",
    premium: "Premium",
    default: "Por Defecto",
    classic: "Clásico",
    viewMode: "Modo de Vista",
    viewModeDescription: "Elige cómo quieres ver el tablero de ajedrez",
    topDown: "Vista Superior",
    topDownDescription: "Vista plana, como los tableros tradicionales",
    perspective3D: "Perspectiva 3D",
    perspective3DDescription: "Piezas 2D clásicas con ángulo de tablero 3D dinámico",
    skinsApplyTo: "Los skins se aplican a Rey, Reina, Torre, Alfil, Caballo, Peón",
    dukeHint: "Izquierda: Rey Instantáneo · Derecha: Lucha por ser Rey"
  },
  
  // Skin Store
  store: {
    title: "Tienda de Skins",
    subtitle: "King's Court",
    riseOfDukes: "Rise of the Dukes",
    chessPieces: "Piezas de Ajedrez",
    dukeSkins: "Skins de Duque",
    allPiecesBundle: "Paquete de Todos los Skins de Piezas",
    allDukeBundle: "Paquete de Todos los Skins de Duque",
    bundleDiscount: "¡Obtén todos los skins premium con 30% de descuento!",
    owned: "Obtenido",
    equip: "Equipar",
    buy: "Comprar",
    processing: "Procesando...",
    free: "Gratis",
    rare: "raro",
    epic: "épico",
    legendary: "legendario",
    common: "común",
    securePayment: "Compra única • Usa para siempre • Pago seguro vía Stripe"
  },
  
  // Chat
  chat: {
    title: "Chat",
    lobbyChat: "Chat del Vestíbulo",
    gameChat: "Chat del Juego",
    typeMessage: "Escribe un mensaje...",
    send: "Enviar",
    spectatorChat: "Chat de Espectadores",
    playerChat: "Chat de Jugadores"
  },
  
  // Friends
  friends: {
    title: "Amigos",
    online: "En Línea",
    offline: "Desconectado",
    addFriend: "Agregar Amigo",
    removeFriend: "Eliminar",
    invite: "Invitar",
    pending: "Pendiente",
    accept: "Aceptar",
    decline: "Rechazar",
    friendRequests: "Solicitudes de Amistad",
    noFriends: "Sin amigos aún",
    searchPlayers: "Buscar jugadores..."
  },
  
  // Notifications
  notifications: {
    friendRequest: "te envió una solicitud de amistad",
    gameInvite: "te invitó a jugar",
    yourTurn: "¡Es tu turno!",
    opponentJoined: "El oponente se unió al juego",
    opponentLeft: "El oponente abandonó el juego",
    drawOffered: "El oponente ofreció tablas",
    connected: "Conectado al servidor",
    disconnected: "Desconectado del servidor",
    reconnecting: "Reconectando..."
  },
  
  // Errors
  errors: {
    invalidEmail: "Correo electrónico inválido",
    invalidPassword: "La contraseña debe tener al menos 6 caracteres",
    passwordMismatch: "Las contraseñas no coinciden",
    loginFailed: "Inicio de sesión fallido. Verifica tus credenciales.",
    registerFailed: "Registro fallido. Intenta de nuevo.",
    connectionError: "Error de conexión. Intenta de nuevo.",
    connectionErrorInternet: "Error de conexión. Verifica tu internet.",
    gameNotFound: "Juego no encontrado",
    roomFull: "La sala está llena",
    invalidMove: "Movimiento inválido",
    pleaseEnterName: "Por favor ingresa tu nombre",
    completeBothSecurityQuestions: "Completa ambas preguntas de seguridad o déjalas vacías",
    selectDifferentQuestions: "Por favor selecciona preguntas diferentes",
    unexpectedError: "Ocurrió un error inesperado",
    failedToSendResetCode: "Error al enviar código de restablecimiento",
    invalidOrExpiredCode: "Código inválido o expirado",
    failedToResetPassword: "Error al restablecer contraseña. Intenta de nuevo.",
    pleaseEnterRoomName: "Por favor ingresa un nombre de sala",
    pleaseEnterRoomCode: "Por favor ingresa un código de sala",
    roomCodeMustBe6Chars: "El código debe tener 6 caracteres",
    roomNotFound: "Sala no encontrada. Verifica el código.",
    roomRequiresApproval: "Esta sala requiere aprobación. Solicita unirte desde tu lista.",
    failedToCreateRoom: "Error al crear sala",
    failedToJoinRoom: "Error al unirse a la sala",
    failedToLeaveRoom: "Error al salir de la sala",
    failedToRemoveRoom: "Error al eliminar sala",
    failedToLoadGames: "Error al cargar juegos",
    failedToRequestRejoin: "Error al solicitar reincorporación",
    failedToJoinMatchmaking: "Error al unirse al emparejamiento",
    noOpponentFound: "No se encontró oponente. Intenta más tarde.",
    searchFailed: "Búsqueda fallida",
    failedToSendRequest: "Error al enviar solicitud",
    failedToAcceptRequest: "Error al aceptar solicitud",
    failedToRejectRequest: "Error al rechazar solicitud",
    failedToCancelRequest: "Error al cancelar solicitud",
    failedToRemoveFriend: "Error al eliminar amigo"
  },
  
  // Success Messages
  success: {
    copiedToClipboard: "¡Copiado al portapapeles!",
    rejoinRequestSent: "¡Solicitud enviada al anfitrión!",
    roomRemovedFromList: "Sala eliminada de tu lista.",
    leftRoomSuccessfully: "Saliste de la sala exitosamente",
    requestRejected: "Solicitud rechazada",
    requestCancelled: "Solicitud cancelada",
    friendRemoved: "Amigo eliminado",
    tournamentCreated: "¡Torneo creado exitosamente!",
    tournamentJoined: "¡Te uniste al torneo!",
    tournamentLeft: "Saliste del torneo",
    tournamentStarted: "¡Torneo iniciado!",
    tournamentCancelled: "Torneo cancelado",
    tournamentsCleared: "Todos los torneos eliminados",
    removedFromHistory: "Eliminado del historial"
  },
  
  // Tournament
  tournament: {
    title: "Torneos",
    createTournament: "Crear Torneo",
    joinTournament: "Unirse al Torneo",
    leaveTournament: "Salir del Torneo",
    startTournament: "Iniciar Torneo",
    cancelTournament: "Cancelar Torneo",
    clearAll: "Borrar Todo",
    myTournaments: "Mis Torneos",
    availableTournaments: "Torneos Disponibles",
    tournamentHistory: "Historial de Torneos",
    bracket: "Bracket",
    participants: "Participantes",
    status: "Estado",
    waiting: "Esperando",
    inProgress: "En Progreso",
    completed: "Completado",
    cancelled: "Cancelado",
    format: "Formato",
    singleElimination: "Eliminación Simple",
    doubleElimination: "Doble Eliminación",
    swiss: "Suizo",
    round: "Ronda",
    match: "Partida",
    ready: "Listo",
    notReady: "No Listo",
    markReady: "Marcar Listo",
    winner: "Ganador",
    loser: "Perdedor",
    bye: "Pase",
    pleaseLoginToCreate: "Inicia sesión para crear un torneo",
    pleaseLoginToJoin: "Inicia sesión para unirte a un torneo",
    failedToLoadTournaments: "Error al cargar torneos",
    failedToCreateTournament: "Error al crear torneo",
    failedToJoinTournament: "Error al unirse al torneo",
    failedToLeaveTournament: "Error al salir del torneo",
    failedToStartTournament: "Error al iniciar torneo",
    failedToCancelTournament: "Error al cancelar torneo",
    failedToClearTournaments: "Error al borrar torneos",
    failedToRemoveFromHistory: "Error al eliminar del historial",
    failedToLoadTournament: "Error al cargar torneo",
    failedToMarkReady: "Error al marcar como listo"
  },
  
  // Ranked
  ranked: {
    title: "Clasificatorio",
    findMatch: "Buscar Partida Clasificatoria",
    inQueue: "En Cola...",
    leaveQueue: "Salir de la Cola",
    yourRank: "Tu Rango",
    elo: "ELO",
    tier: "Nivel",
    wins: "Victorias",
    losses: "Derrotas",
    draws: "Empates",
    season: "Temporada",
    leaderboard: "Clasificación",
    squire: "Escudero",
    knight: "Caballero",
    baron: "Barón",
    duke: "Duque",
    king: "Rey",
    pleaseLoginToPlay: "Inicia sesión para jugar clasificatorio",
    failedToJoinQueue: "Error al unirse a la cola"
  },

  // Misc
  misc: {
    loading: "Cargando...",
    cancel: "Cancelar",
    confirm: "Confirmar",
    yes: "Sí",
    no: "No",
    ok: "OK",
    save: "Guardar",
    delete: "Eliminar",
    edit: "Editar",
    back: "Atrás",
    next: "Siguiente",
    previous: "Anterior",
    search: "Buscar",
    filter: "Filtrar",
    sort: "Ordenar",
    all: "Todo",
    none: "Ninguno",
    select: "Seleccionar",
    selected: "Seleccionado"
  },
  
  // About Us Page
  aboutUs: {
    back: "← Volver",
    title: "Bienvenido a Chess Kingdom: King's Court",
    subtitle: "King's Court",
    riseOfDukes: "Rise of the Dukes",
    description: "Entra en un reino donde la estrategia clásica se encuentra con la escala mítica. King's Court es más que un modo de juego: es un campo de pruebas para tácticos, soñadores y campeones por igual. Ya seas un gran maestro buscando un nuevo desafío o un recién llegado atraído por la emoción de la conquista, esta es tu arena. ⚔️",
    keyFeatures: "Características Principales",
    feature1Title: "Variantes Dinámicas",
    feature1Desc: "Explora conjuntos de reglas y diseños de tablero en evolución que ponen a prueba tu adaptabilidad y previsión.",
    feature2Title: "Progresión Cortesana",
    feature2Desc: "Gana títulos, desbloquea emblemas y asciende a través de un sistema de clasificación ricamente estratificado que recompensa la maestría y el estilo.",
    feature3Title: "Juego Basado en Habilidad",
    feature3Desc: "Retroalimentación transparente, equilibrio ajustado por telemetría y emparejamiento justo aseguran que cada victoria se sienta merecida.",
    feature4Title: "Chat en Vivo e Hilos de Historia",
    feature4Desc: "Conéctate con rivales y aliados, descubre la tradición procedural y da forma a la mitología de tu reino.",
    feature5Title: "Hecho para Profesionales",
    feature5Desc: "Ajuste de precisión, análisis de repetición e infraestructura lista para torneos hacen de King's Court una plataforma seria para el juego competitivo.",
    closingStatement: "Ya sea que busques gloria, crecimiento o gran estrategia, King's Court te invita a gobernar con sabiduría, luchar con honor y dejar tu huella en el reino.",
    developmentNotice: "Nota: El juego aún está en desarrollo, y con tu paciencia y apoyo, el juego se convertirá en un hogar lejos del hogar. Diviértete, haz amigos y alianzas, porque cuando termine, tus métodos estratégicos de ganar serán puestos a prueba... Bienvenido a tu Reino...",
    contactTitle: "Más información o sugerencias Contactar:",
    contactEmail: "CKKC.customerservice@gmail.com"
  },
  
  // Store
  store: {
    title: "Tienda de Skins",
    themedSets: "Sets Temáticos",
    pieceSkins: "Skins de Piezas",
    dukeSkins: "Skins de Duque",
    unlockSet: "Desbloquear Set",
    owned: "Adquirido",
    price: "Precio",
    checkout: "Pagar",
    addToCart: "Añadir al Carrito",
    cart: "Carrito",
    total: "Total",
    continueShopping: "Seguir Comprando",
    proceedToCheckout: "Proceder al Pago",
    emptyCart: "Tu carrito está vacío",
    itemAdded: "Artículo añadido al carrito",
    purchaseSuccess: "¡Compra exitosa!",
    purchaseFailed: "Compra fallida. Por favor, inténtalo de nuevo."
  },
  
  // Rules
  rules: {
    title: "Reglas del Juego",
    classic: "Ajedrez Clásico",
    classicDesc: "Reglas estándar de ajedrez - da jaque mate al rey enemigo para ganar.",
    instantKing: "Rey Instantáneo",
    instantKingDesc: "¡Captura al rey enemigo directamente para ganar - no necesitas jaque mate!",
    fightToBeKing: "Lucha por ser Rey",
    fightToBeKingDesc: "¡Tu peón promovido se convierte en el nuevo rey! Protégelo o perderás el juego.",
    timerRules: "Reglas del Temporizador",
    timerDesc: "Cada jugador tiene tiempo limitado por movimiento. Si el tiempo se acaba, tu turno se salta."
  },
  
  // Assistant
  assistant: {
    title: "Asistente de Chess Kingdom",
    searchPlaceholder: "Buscar temas de ayuda...",
    randomTip: "Muéstrame un consejo aleatorio",
    noResults: "No se encontraron temas de ayuda para",
    noResultsHint: "Prueba con otras palabras clave o navega por las categorías",
    categories: {
      gettingStarted: "Comenzar",
      dukeMechanics: "Mecánicas del Duque",
      multiplayer: "Multijugador",
      customization: "Personalización",
      boardFeatures: "Tablero",
      skinStore: "Tienda de Skins",
      trialPayments: "Prueba y Pagos",
      strategyTips: "Estrategia",
      troubleshooting: "Soluciones"
    },
    gettingStarted: {
      q1: "¿Cómo empiezo a jugar?",
      a1: "Haz clic en 'Juego Solo' para jugar contra IA, o 'Multijugador' para jugar con otros. Puedes jugar como invitado o registrarte para una prueba gratuita de 48 horas.",
      q2: "¿Cuáles son las variantes del juego?",
      a2: "Chess Kingdom ofrece 7 variantes: Ajedrez Estándar, Rey Instantáneo, Lucha por ser Rey, Elección del Jugador, Peones Salvajes, Chess Kingdom (Dos Duques), y Modo Handicap.",
      q3: "¿Cómo personalizo el tablero?",
      a3: "Haz clic en Configuración para acceder a las opciones. Puedes cambiar colores del tablero, skins de piezas, skins del duque, temas, color de coordenadas, modo de vista y tamaño del tablero.",
      q4: "¿Cómo volteo la vista del tablero?",
      a4: "Haz clic en el botón de voltear en el encabezado del juego para ver el tablero desde la perspectiva de las negras.",
      q5: "¿Cómo cambio el tamaño del tablero?",
      a5: "Ve a Configuración → Tamaño del Tablero. Usa el deslizador o haz clic en 'Compacto' (85%), 'Predeterminado' (100%), o 'Grande' (115%)."
    },
    dukeMechanics: {
      q1: "¿Qué es la pieza Duque?",
      a1: "El Duque es una pieza especial que reemplaza a un Alfil. Se mueve en diagonal (1 casilla) para movimientos sin captura, pero puede capturar en las 8 direcciones (solo casillas adyacentes).",
      q2: "¿Qué pasa cuando mi Rey es capturado?",
      a2: "¡Tu Duque se transforma en un nuevo Rey! Las reglas de transformación dependen del modo: Rey Instantáneo o Lucha por ser Rey.",
      q3: "¿Cómo funciona Lucha por ser Rey?",
      a3: "Después de que tu Rey es capturado, tu Duque debe regresar a su línea base inicial (fila 1 para blancas, fila 8 para negras) para transformarse en Rey.",
      q4: "¿Se pueden promover las piezas Duque?",
      a4: "¡Solo en la variante Peones Salvajes! Cuando un peón llega al final, puedes promocionarlo a Dama, Torre, Alfil, Caballo o Duque.",
      q5: "¿Cuál es la diferencia entre los skins de Rey Instantáneo y Lucha por ser Rey?",
      a5: "Los skins del Duque vienen en dos versiones: La versión 'Rey Instantáneo' aparece durante el juego normal, mientras que 'Lucha por ser Rey' aparece cuando tu Duque lucha por llegar a la línea base."
    },
    multiplayer: {
      q1: "¿Cómo funciona la Partida Rápida?",
      a1: "¡La Partida Rápida te empareja con otro jugador al instante! Selecciona tu modo preferido, haz clic en 'Buscar Partida', y serás emparejado con alguien que eligió el mismo modo.",
      q2: "¿Cómo creo y administro salas privadas?",
      a2: "Ve a la pestaña 'Crear Sala', ingresa un nombre, elige la variante, configura los espectadores y comparte el código de 6 caracteres con amigos.",
      q3: "¿Cómo me uno a la sala de un amigo?",
      a3: "Ve a la pestaña 'Unirse a Sala', ingresa el código de 6 caracteres que tu amigo compartió y haz clic en 'Unirse'.",
      q4: "¿Cuáles son las configuraciones de espectadores?",
      a4: "Privada: Sin espectadores. Solicitar Unirse: Los espectadores deben pedir aprobación. Abierta: Cualquiera puede ver libremente.",
      q5: "¿Cómo veo partidas como espectador?",
      a5: "Ve a la pestaña 'Espectador' para ver todas las partidas públicas. Filtra por tipo de juego para encontrar variantes específicas.",
      q6: "¿Puedo chatear durante las partidas?",
      a6: "¡Sí! Durante las partidas multijugador, usa el chat del juego. ¡Los mensajes se traducen automáticamente si los jugadores hablan diferentes idiomas!",
      q7: "¿Mi tema se sincroniza con los oponentes?",
      a7: "¡Sí! Si eres el anfitrión, tu tema del tablero, skins de piezas y skins del duque se sincronizan automáticamente con todos los jugadores."
    },
    customization: {
      q1: "¿Qué skins de piezas están disponibles?",
      a1: "Tenemos más de 20 sets: Dorado 3D, Obsidiana 3D, Vintage, Kawaii, Fable, Gótico, Colosal, Amatista Púrpura, Zafiro Azul, Reino de Piedra y Arena, ¡y más!",
      q2: "¿Qué skins del duque están disponibles?",
      a2: "Más de 50 skins en categorías: Metálico (Oro, Plata), Color (Púrpura, Azul, Esmeralda), Blanco (Espartano, Águila), Negro (Acero, Corona), Gema, Reino, Premium 3D, ¡y más!",
      q3: "¿Cómo cambio los skins de las piezas?",
      a3: "Configuración → Skins de Piezas. ¡Puedes establecer diferentes skins para el lado blanco y negro por separado! Usa 'Vista previa de ambos lados' para ver cómo se verán juntos.",
      q4: "¿Cómo cambio los skins del duque?",
      a4: "Configuración → Skins del Duque. Selecciona skins categorizados por Blanco, Negro o Neutral. Cada duque tiene variantes de Rey Instantáneo y Lucha por ser Rey.",
      q5: "¿Qué son los Paquetes de Temas?",
      a5: "¡Los Paquetes de Temas agrupan skins de piezas, skins del duque y temas del tablero! Incluyen Royal Gold, Dark Knight, Vintage Classic, ¡y paquetes de Batalla de Reinos!",
      q6: "¿Cómo obtengo un tema aleatorio?",
      a6: "Haz clic en 'Paquete de Tema Aleatorio' para aplicar un tema completo al azar, o 'Batalla de Reino Aleatoria' para un enfrentamiento de facciones.",
      q7: "¿Puedo personalizar los colores de las coordenadas?",
      a7: "¡Sí! Configuración → Color de Coordenadas. Elige cualquier color para los números de fila (1-8) y letras de columna (a-h)."
    },
    boardFeatures: {
      q1: "¿Cuáles son los modos de vista?",
      a1: "Dos modos: Perspectiva 3D (con profundidad y sombras) y Vista Superior (plano, tradicional). Cambia en Configuración → Modo de Vista.",
      q2: "¿Cómo funciona el tamaño del tablero?",
      a2: "Configuración → Tamaño del Tablero te permite escalar del 80% (Compacto) al 120% (Grande). El predeterminado es 100%.",
      q3: "¿Qué temas de tablero están disponibles?",
      a3: "Múltiples temas de colores: Madera Clásica, Oro Real, Caballero Oscuro, Azul Océano, Verde Bosque, Gris Piedra, y más.",
      q4: "¿Cómo funcionan las coordenadas?",
      a4: "Las coordenadas muestran números de fila (1-8) y letras de columna (a-h) en los bordes del tablero. ¡Se voltean correctamente al usar el botón de voltear!",
      q5: "¿El tablero funciona en móvil?",
      a5: "¡Sí! El tablero es completamente responsive. En modo horizontal, el tablero se ajusta automáticamente a la altura de la pantalla."
    },
    skinStore: {
      q1: "¿Cómo accedo a la Tienda de Skins?",
      a1: "Haz clic en el botón Tienda desde el vestíbulo, o accede a través de Configuración → botón 'Visitar Tienda'. La tienda tiene tres pestañas: Sets Temáticos, Skins de Piezas y Skins del Duque.",
      q2: "¿Qué son los Sets Temáticos?",
      a2: "¡Paquetes de temas completos con descuento! Incluyen skins de piezas, skins del duque y temas del tablero que combinan.",
      q3: "¿Hay descuentos por paquete?",
      a3: "¡Sí! 'Paquete de Todas las Piezas' y 'Paquete de Todos los Duques' te dan todos los skins con 40% de descuento.",
      q4: "¿Cómo funcionan las rarezas de los skins?",
      a4: "Común (gris): Gratis o básico. Raro (azul): $1.99-2.49. Épico (púrpura): $2.49-3.99. Legendario (oro): $3.49-4.99.",
      q5: "¿Puedo ver una vista previa antes de comprar?",
      a5: "¡Sí! Pasa el cursor sobre cualquier tarjeta de skin para ver una vista previa. Los skins de piezas muestran Rey, Dama y Caballo.",
      q6: "¿Cómo equipo los skins comprados?",
      a6: "En la Tienda, los skins que posees muestran el botón 'Equipar' en lugar del precio. Haz clic en Equipar para aplicar inmediatamente."
    },
    trialPayments: {
      q1: "¿Qué es la prueba gratuita de 48 horas?",
      a1: "Los nuevos usuarios obtienen 48 horas de acceso gratuito a TODAS las variantes. Después de la prueba, el Ajedrez Estándar y Rey Instantáneo permanecen gratuitos.",
      q2: "¿Cuánto cuestan las variantes?",
      a2: "Lucha por ser Rey y Modo Handicap: $2.99, Elección del Jugador: $3.99, Peones Salvajes y Dos Duques: $4.99. ¡O consigue el Paquete de Todas las Variantes por $8.99!",
      q3: "¿Cuánto cuestan los skins?",
      a3: "Skins individuales: $1.99-$4.99 dependiendo de la rareza. Paquetes: ~40% de descuento. Sets Temáticos: $8.99-$12.99.",
      q4: "¿Puedo jugar como invitado?",
      a4: "¡Sí! El modo invitado permite jugar inmediatamente sin registrarse. Sin embargo, el historial de juegos no se guardará.",
      q5: "¿Cómo funcionan los pagos?",
      a5: "Todos los pagos se procesan de forma segura a través de Stripe. Las compras únicas desbloquean el contenido para siempre. No se requieren suscripciones."
    },
    strategyTips: {
      q1: "¿Estrategia de apertura del Duque?",
      a1: "Posiciona tu Duque para controlar las diagonales centrales temprano. Su capacidad única de captura en 8 direcciones lo hace excelente para amenazar múltiples piezas.",
      q2: "¿Cuándo elegir Rey Instantáneo vs Lucha por ser Rey?",
      a2: "Elige Rey Instantáneo si tu Duque está bien posicionado. Elige Lucha por ser Rey si tu Duque ya está cerca de la línea base.",
      q3: "¿Estrategia de la variante Dos Duques?",
      a3: "¡Protege ambos Duques cuidadosamente - son tus 'vidas extra'! Cuando tu Rey sea capturado, elige el Duque más seguro para la transformación.",
      q4: "¿Final de Peones Salvajes?",
      a4: "¡Considera promover peones a Duques como 'seguro de Rey' - si tu Rey es capturado después, un Duque promovido puede convertirse en tu nuevo Rey!",
      q5: "¿Usar el volteo del tablero estratégicamente?",
      a5: "¡Voltea el tablero para ver posiciones desde la perspectiva de tu oponente! Esto ayuda a identificar amenazas que podrías pasar por alto."
    },
    troubleshooting: {
      q1: "El juego carga lentamente",
      a1: "Prueba el botón Solucionador de Problemas para ejecutar diagnósticos. Verifica tu conexión a internet. Intenta actualizar la página (Ctrl+F5).",
      q2: "El multijugador no conecta",
      a2: "Usa el Solucionador de Problemas para verificar el estado de la conexión WebSocket. Asegúrate de haber iniciado sesión. Verifica problemas de firewall/VPN.",
      q3: "La configuración no se guarda",
      a3: "La configuración usa localStorage. Verifica si tu navegador lo permite. Prueba la opción 'Restablecer Configuración' del Solucionador de Problemas.",
      q4: "¿Dónde está el historial de movimientos?",
      a4: "La barra lateral del historial de movimientos aparece en el lado DERECHO durante las partidas activas. Requiere un ancho de navegador > 768px.",
      q5: "¿El deslizador de tamaño del tablero no funciona?",
      a5: "Intenta: 1) Actualizar la página. 2) Limpiar caché del navegador. 3) Verificar si estás en una partida. 4) Probar diferente modo de vista.",
      q6: "¿Las piezas se ven muy pequeñas/grandes?",
      a6: "Diferentes skins de piezas tienen diferentes tamaños óptimos. Ve a Configuración → Tamaño del Tablero para ajustar.",
      q7: "¿Olvidé mi contraseña?",
      a7: "Ve a la página de Cuenta → '¿Olvidaste tu Contraseña?' → Responde tus preguntas de seguridad → La contraseña se enviará a tu correo.",
      q8: "¿Cómo contacto al soporte?",
      a8: "Usa el Solucionador de Problemas para problemas técnicos. Para problemas de facturación/cuenta, envía un correo desde la página de Cuenta."
    },
    tips: {
      tip1: "¡El Duque puede capturar en 8 direcciones pero solo se mueve en diagonal cuando no captura!",
      tip2: "En modo Lucha por ser Rey, tu Duque debe llegar a la línea base para transformarse.",
      tip3: "¡Posiciona tu Duque para controlar múltiples casillas - su movimiento único es poderoso!",
      tip4: "En la variante Dos Duques, proteger ambos Duques te da más opciones de remontada.",
      tip5: "En Peones Salvajes, promover a Duque te da 'seguro de Rey' si es capturado.",
      tip6: "¡Partida Rápida: Selecciona el mismo modo que tu oponente para ser emparejado al instante!",
      tip7: "Las salas creadas aparecen en 'Mis Salas', las salas unidas aparecen en 'Salas Unidas'.",
      tip8: "¡Configura tu sala como 'Abierta' para que cualquiera pueda ver tus partidas épicas!",
      tip9: "Modo Solicitar: Los jugadores deben aprobar espectadores - perfecto para sesiones de enseñanza privadas.",
      tip10: "Puedes crear máximo 5 salas. Cancela o completa para crear más.",
      tip11: "Haz clic en Configuración para cambiar los colores del tablero y las piezas en cualquier momento.",
      tip12: "Todos tus movimientos se registran en la barra lateral del lado derecho de la pantalla.",
      tip13: "¡Los mensajes se traducen automáticamente para jugadores que hablan diferentes idiomas!",
      tip14: "Cada sala privada obtiene un código único de 6 caracteres para compartir con amigos.",
      tip15: "¡Paquetes de Temas: Obtén piezas, duques y temas del tablero que combinan en un clic!",
      tip16: "¡Prueba Piedra y Arena vs Guerreros del Bosque para una guerra de facciones épica!",
      tip17: "¡Deja que el juego elija un tema aleatorio para ti - descubre nuevos favoritos!",
      tip18: "¡Amatista Púrpura y Zafiro Azul hacen que tus piezas brillen!",
      tip19: "¡Haz clic en el botón de voltear para ver desde la perspectiva de las negras - genial para análisis!",
      tip20: "¡Rota tu dispositivo para una vista más grande del tablero en móvil!",
      tip21: "¡Usa el deslizador en Configuración para escalar el tablero del 80% al 120%!",
      tip22: "¡Los sets Colosal presentan piezas esculpidas épicas de mármol y bronce!",
      tip23: "¡Cuatro lindos sets de piezas emoji Kawaii - Marrón, Blanco, Negro y Beige!",
      tip24: "¡Los sets Gótico Blanco y Negro presentan diseños intrincados de fantasía oscura!",
      tip25: "¡Fable Medieval: Caballeros cruzados vs guerreros oscuros - piezas de batalla épica!"
    }
  },

  // Account Manager
  account: {
    title: "Gestión de Cuenta",
    accountInfo: "Información de la Cuenta",
    usernameEmail: "Usuario/Correo",
    displayName: "Nombre para Mostrar",
    accountType: "Tipo de Cuenta",
    userId: "ID de Usuario",
    guest: "Invitado",
    registered: "Registrado",
    notAvailable: "N/D",
    notificationSettings: "Configuración de Notificaciones",
    notificationSound: "Sonido de Notificación",
    notificationSoundDesc: "Reproducir un sonido cuando recibas notificaciones",
    security: "Seguridad",
    passwordManagement: "Gestión de Contraseña",
    passwordNote: "Por razones de seguridad, no mostramos contraseñas. Si necesitas restablecer tu contraseña, usa la función 'Olvidé mi Contraseña'.",
    forgotPassword: "¿Olvidaste tu Contraseña?",
    passwordRecovery: "Recuperación de Contraseña",
    passwordRecoveryHelp: "Responde tus preguntas de seguridad para recibir tu contraseña por correo",
    securityQuestion1: "Pregunta de Seguridad 1",
    securityQuestion2: "Pregunta de Seguridad 2",
    selectQuestion: "Selecciona una pregunta...",
    yourAnswer: "Tu respuesta",
    sendPasswordEmail: "Enviar Contraseña por Correo",
    securityQuestions: {
      q1: "¿Cuál era el nombre de tu primera mascota?",
      q2: "¿En qué ciudad naciste?",
      q3: "¿Cuál es el apellido de soltera de tu madre?",
      q4: "¿Cuál era el nombre de tu escuela primaria?",
      q5: "¿Cuál es tu libro favorito?",
      q6: "¿Cuál era tu apodo de infancia?",
      q7: "¿Cuál es el nombre de tu profesor favorito?",
      q8: "¿En qué calle creciste?"
    },
    dangerZone: "Zona de Peligro",
    deleteAccount: "Eliminar Cuenta",
    deleteAccountDesc: "Eliminar permanentemente tu cuenta y todos los datos asociados.",
    deleteWarning: "Esto eliminará permanentemente:",
    deleteWarningItems: {
      account: "Tu cuenta y perfil",
      gameHistory: "Todo el historial de juegos",
      friends: "Conexiones de amigos",
      purchases: "Variantes compradas",
      settings: "Configuración y preferencias"
    },
    typeDelete: "Escribe DELETE para confirmar:",
    typeDeletePlaceholder: "Escribe DELETE aquí",
    deleteForever: "Eliminar Mi Cuenta Para Siempre",
    deleteConfirmMsg: "Esta acción no se puede deshacer.",
    deleteSuccess: "Cuenta eliminada exitosamente. Serás desconectado.",
    deleteFailed: "Error al eliminar la cuenta",
    passwordResetSuccess: "¡Restablecimiento exitoso! Tu contraseña ha sido enviada a tu correo. Revisa tu bandeja de entrada (y carpeta de spam).",
    securityAnswersIncorrect: "Respuestas de seguridad incorrectas. Por favor, inténtalo de nuevo.",
    passwordResetFailed: "Error al restablecer la contraseña. Por favor, inténtalo de nuevo.",
    answerBothQuestions: "Por favor responde ambas preguntas de seguridad"
  }
};

export default es;
